console.group("Did someone tell you to paste or type something here?");
console.log(
	"Jamart© website will NEVER instruct it's users to paste anything in this area. If someone online has told you to paste anything in this area kindly disregard it for your own protection."
);
console.log(
	"If you write anything in this area please be aware of what you are doing"
);
console.groupEnd();
